// @ts-nocheck
import React, { useState, useEffect } from 'react'
import * as PropTypes from 'prop-types'
// Components
import { Checkbox as MuiCheckbox, Switch as MuiSwitch, FormControlLabel } from '@mui/material'
import { Forms } from '../schema'
import { events } from '@ggs/utils'
// Assets
import './_Checkbox.scss'
import './_Switch.scss'

const propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  disabled: PropTypes.bool,
  labelPlacement: PropTypes.string,
}

const defaultProps = {
  label: '',
  name: '',
  value: false,
  disabled: false,
  labelPlacement: Forms.LabelPlacement.top,
}

// eslint-disable-next-line react/display-name
const Checkbox = (props) => {
  const {
    value,
    onChange,
    className,
    label,
    name,
    isSwitch = false,
    disabled,
    labelPlacement,
    inputProps,
    checked,
    sx,
  } = props

  const [isChecked, setIsChecked] = useState(checked || false)
  const handleChange = (event) => {
    // console.log('CheckboxHandleChange: ', event.target.checked)
    setIsChecked(event.target.checked)
    onChange && onChange(event)
  }

  const controllerProps = {
    onChange: handleChange,
    disabled,
    inputProps,
    name,
    value,
    sx,
    checked: isChecked,
  }

  // console.log('CheckboxPropsNew:', controllerProps)

  useEffect(() => {
    setIsChecked(checked)
  }, [checked])

  const reset = () => {
    handleChange(events.syntheticInputEvent(name, { checked: false }))
  }

  return (
    <>
      <FormControlLabel
        className={className}
        control={
          isSwitch ? <MuiSwitch {...controllerProps} /> : <MuiCheckbox {...controllerProps} />
        }
        label={label}
        labelPlacement={labelPlacement}
      />
      <button
        className="form-field__reset"
        data-name={name}
        type="button"
        aria-hidden
        onClick={reset}
      />
    </>
  )
}

// Export Props
Checkbox.defaultProps = defaultProps
Checkbox.propTypes = propTypes
// Export Component
export default Checkbox
